// src/pages/DashboardCartas.js
import React, { useContext, useState, useEffect } from "react";
import AdminLayout from "../components/AdminLayout";
import { AuthContext } from "../contexts/AuthContext";
import axios from "axios";

function DashboardCartasInfo() {
  const { user } = useContext(AuthContext);
  const [stats, setStats] = useState({
    totalCartas: 0,
    newCartas: 0,
    pendingCartas: 0,
    resolvedCartas: 0,
  });
  const [lastCartas, setLastCartas] = useState([]);
  const [loadingStats, setLoadingStats] = useState(true);
  const [loadingLast, setLoadingLast] = useState(true);

  // Busca as estatísticas das cartas
  useEffect(() => {
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}cartas/dashboard/`)
        .then((response) => {
          setStats(response.data);
          setLoadingStats(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar estatísticas das cartas:", error);
          setLoadingStats(false);
        });
    }
  }, [user]);

  // Busca as últimas cartas registradas
  useEffect(() => {
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}cartas/ultimas/`)
        .then((response) => {
          setLastCartas(response.data);
          setLoadingLast(false);
        })
        .catch((error) => {
          console.error("Erro ao carregar últimas cartas:", error);
          setLoadingLast(false);
        });
    }
  }, [user]);

  // Renderização condicional
  if (!user) {
    return (
      <AdminLayout>
        <div>Carregando usuário...</div>
      </AdminLayout>
    );
  }

  if (loadingStats) {
    return (
      <AdminLayout>
        <div>Carregando estatísticas...</div>
      </AdminLayout>
    );
  }

  return (
    <>
      {/* Cabeçalho do Dashboard */}
      <div
        className="page-header d-print-none"
        style={{ marginTop: "0px", paddingBottom: "18px" }}
      >
        <div className="row align-items-center">
          <div className="col">
            <h2 className="page-title">Dashboard Cartas</h2>
            <div className="text-muted mt-1">
              Resumo das atividades das cartas
            </div>
          </div>
        </div>
      </div>

      {/* Widgets de estatísticas */}
      <div className="row row-deck row-cards" style={{ marginTop: "0px", paddingBottom: "8px" }}>
        {/* Widget: Total de Cartas */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Total de Cartas</div>
              </div>
              <div className="h1 mb-3">{stats.totalCartas}</div>
              <div className="text-secondary">Cartas registradas</div>
            </div>
          </div>
        </div>

        {/* Widget: Novas Cartas */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">Novas Cartas</div>
              </div>
              <div className="h1 mb-3">{stats.newCartas}</div>
              <div className="text-secondary">Cartas adicionadas hoje</div>
            </div>
          </div>
        </div>

        {/* Widget: Cartas Pendentes */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">
                <span className="badge bg-danger text-white opacity-70">
                  Cartas Pendentes
                </span>
                </div>
              </div>
              <div className="h1 mb-3">{stats.pendingCartas}</div>
              <div className="text-secondary">Em espera de atendimento</div>
            </div>
          </div>
        </div>

        {/* Widget: Cartas Resolvidas */}
        <div className="col-sm-6 col-lg-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="subheader">
                <span className="badge bg-success text-white opacity-70">
                  Cartas Resolvidas
                </span>
                </div>
              </div>
              <div className="h1 mb-3">{stats.resolvedCartas}</div>
              <div className="text-secondary">Atendidas</div>
            </div>
          </div>
        </div>
      </div>

      {/* Lista das Últimas Cartas */}
      {loadingLast ? (
        <div>Carregando últimas cartas...</div>
      ) : (
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Últimas Cartas</h3>
          </div>
          <div className="list-group list-group-flush list-group-hoverable">
            {lastCartas.length === 0 ? (
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col text-center">Nenhuma carta encontrada.</div>
                </div>
              </div>
            ) : (
              lastCartas.map((carta, index) => (
                <div key={index} className="list-group-item">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <span className="avatar avatar-1">
                        {carta.solicitante ? carta.solicitante.charAt(0).toUpperCase() : "?"}
                      </span>
                    </div>
                    <div className="col text-truncate">
                      <a href="#" className="text-reset d-block">
                        {carta.solicitante.toUpperCase()}
                      </a>
                      <div className="d-block text-secondary text-truncate mt-n1">
                        {carta.solicitacao.toUpperCase()}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardCartasInfo;